import { ActionType, CompartType } from '../../../app/entities';
import { SystemComponentViewModel } from '../inventory/inventory-models';
export class CreateActionViewModel {
  public ActionTypeId: number;
  public ReplaceCompartment: ReplacementCompartmentViewModel;
  public CMU: number;
  public BudgetLife: number;
  public PartCost: number;
  public LabourCostOption: number;
  public LabourCost: number;
  public MiscCost: number;
  public ActionDate: Date;
  public Comment: string;
  public HourlyRate: number;
  public SMU: number;
  public GeneralEqUnitId: number;
  public CompartId: number;

  constructor() {
    this.ActionDate = new Date();
    this.LabourCostOption = 0;
  }
}

export class ReplaceActionViewModel extends CreateActionViewModel {
  public EquipmentId: number;
  public ComponentLife: number;
  public Side: number;
  public BrandId: number;
  public Position: number;
  public SystemId: number;
  constructor() {
    super();
  }
}

export class ReplacementCompartmentViewModel {
  public Id: number;
  public Name: string;
  public CompartType: number;
  public isChild: boolean;
  public isParent: boolean;
  public BudgetLife: number;
  public BudgetDistance: number;
}

export class ActionSystemViewModel {
  public SystemId: number;
  public SystemSerialNumber: string;
  public JobsiteId: number;
  public SystemAvailableActions: AvailableActionViewModel[];
  public Components: ComponentOnSystemViewModel[];
}

export class ComponentOnSystemViewModel {
  public ComponentImage: string;
  public SystemId: number;
  public GeneralEqunitId: number;
  public CompartTypeId: number;
  public Name: string;
  public Position: string;
  public Worn: number;
  public Cmu: number;
  public Brand: string;
  public ComponentAvailableActions: AvailableActionViewModel[];
  public ActualPosition: number;
  public BudgetLife: number;
}


export class AvailableActionViewModel {
  public ActionTypeId: number;
  public ActionTypeName: string;

  /**
   *
   */
  constructor(Id: number, Name: string) {
    this.ActionTypeId = Id;
    this.ActionTypeName = Name;
  }
}

export class SystemReplaceAction {
  public ActionTypeId = 30;
  public ActionTypeName = 'ReplaceSystemInInventory';
  constructor() {
    this.ActionTypeId = 30;
    this.ActionTypeName = 'ReplaceSystemInInventory';
  }
}

export class ActionInInventoryViewModel {
  public ActionTypeId: number;
  public ActionDate: Date;
  public BudgetLife: number;
  public CMU: number;
  public Comment: string;

  public CompartId: number;

  public PartCost: number;
  public LabourCostOption: number;
  public LabourCost: number;
  public MiscCost: number;
  public HourlyRate: number;
  public ReplaceCompartment: ReplacementCompartmentViewModel;


  public MakeId: number;



  constructor() {
    this.ActionDate = new Date();
    this.LabourCostOption = 0;
    this.PartCost = 0;
    this.LabourCost = 0;
    this.MiscCost = 0;
    this.ActionTypeId = 0;
  }
}

export class InspectionAction{
  public  SMU :number
  public InspectionDate:string;
  public Actiondate:Date;
  public equipmentId:number;
  public IsRSH:boolean;
  public ProbelHrs: number;
  public distanceForward: number;
  public distanceReverse: number;

}

export class ShoeInformationAdd{
  EqunitId:number;
  ShoeId:number;
  CleanerHolesId:number;
  GrouserId:number;
}

export class GeneralActionViewModel {
  public ActionTypeId: number;
  public ActionTypeName: string;
  public ActionDate: Date;
  public BudgetLife: number;
  public BudgetDistance: number;
  public Comment: string;

  public FrameCost: number;
  public PartCost: number;
  public LabourCostOption: number;
  public LabourCost: number;
  public MiscCost: number;
  public HourlyRate: number;
  public Cost: number;


  public EquipmentId: number;
  public MakeId: number;

  public Reed: number;
  public ReedPMU: number;


  public ActionEqUnitId: number;
  public NewEqUnitId: number;

  public ExtendedBudgetLife: number;

  public ReplaceComponentCompartName: string;
  public ReplaceComponentCompartId: number;

  public NewSMU: number;
  public NewPMU: number;


  public StringDate: string;
public WsreId :number;
public SystemType:number;
  constructor() {
    this.ActionDate = new Date();
    this.LabourCostOption = 0;
    this.PartCost = 0;
    this.LabourCost = 0;
    this.MiscCost = 0;
    this.ActionTypeId = 0;
    this.Reed = 0;
    this.ReedPMU = 0;
    this.ExtendedBudgetLife = 0;
    this.Comment = " ";
    this.Cost = 0
  }

  public UsedCMU: number;
  public UsedDOC: number;
  public UsedWorn: number;
  public Measurement: number;
  public ToolId: number;
  public ActionWO:string;
  public ShoeSize:number;
  public GrouserId:number;
  public CleanerHolesId: number;
  public DOEatInstall: number;
  public OldSysInventoryStatusId: number = 1;
}

export class SystemReplacementActionViewModel extends GeneralActionViewModel {
  public NewSystemId: number;
  public OldSystemId: number;
  public EquipmentSMUAtDetachment: number;
  public ActionTypeOnChainOrFrame:number=0;

  constructor(model: GeneralActionViewModel, newSystemId: number, oldSystemId: number,ActionTypeOnChainOrFrame:number) {
    super();
    const rightDate = new Date(model.ActionDate);
    this.ActionDate = rightDate;
    this.StringDate = rightDate.toLocaleDateString('en-US');
    this.ActionDate = model.ActionDate;
    this.ActionTypeId = model.ActionTypeId;
    this.BudgetLife = model.BudgetLife;
    this.Comment = model.Comment;
    this.NewSMU = model.NewSMU;
    this.NewPMU = model.NewPMU;

    this.EquipmentId = model.EquipmentId;
    this.EquipmentSMUAtDetachment = model.NewSMU;
    this.LabourCost = model.LabourCost;
    this.LabourCostOption = model.LabourCostOption;
    this.MakeId = model.MakeId;
    this.MiscCost = model.MiscCost;
    this.NewSystemId = newSystemId;
    this.OldSystemId = oldSystemId;
    this.PartCost = model.PartCost;
    this.HourlyRate = model.HourlyRate;
    this.Reed = model.Reed;
    this.ReedPMU = model.ReedPMU;
    this.ActionTypeOnChainOrFrame = ActionTypeOnChainOrFrame;
    this.DOEatInstall = model.DOEatInstall;
    this.UsedDOC = model.UsedDOC;
    this.OldSysInventoryStatusId = model.OldSysInventoryStatusId;
  }
}



export class AvailableSystemToBeAReplacementViewModel {
  public SystemId: number;
  public SystemSerialNumber: string;

  public MakeName: string;
  public MakeId: number;
  public ModelName: string;
  public ModelId: number;


  public CMU: number;
  public LTD: number;

  public SystemType: number;

  public JobsiteId: number;
  public JobsiteName: number;
  public SMU: number;

  public Components:SystemComponentViewModel[]

}


export class SystemReplacementWillEffectFutureActionsWarningViewModel {
  public ShouldAllowToPerform: boolean;
  public ActionsWillBeEffected: ActionWillBeEffectedViewModel[];
}
export class ActionWillBeEffectedViewModel {
  public ActionHistoryId: number;
  public OldActualLife: number;
  public ActionTypeName: string;

  public ActionDate: Date;
  public SystemId: number;
  public ActionDate_: string;

  public RunningHoursThatBelongsToNewSystem: number;
  public PossibleError: boolean;
}


export class ActionsWillEffectedByAction {
  public NewSystemId: number;
  public OldSystemId: number;
  public EquipmentId: number;
  public ActionDate: Date;
  public UninstallAtSMU: number;
  public StringDate: string;
}



export class ActionResult {
  public OperationSucceed: boolean;
  public Message: string;
  public SavedId: number;
}








export class ReplaceMultipleComponentsOnSystemViewModel {
  public SystemId: number;
  public ModelId: number;
  public MakeId: number;
  public MakeDesc: string;
  public ModelDesc: string;

  public SystemType: number;
  public SystemSide: number;

  public Components: ReplacingComponentsOnSystemViewModel[];
}



export class ReplacingComponentsOnSystemViewModel {
  public GeneralEqUnitId: number;
  public CMU: number;
  public MakeId: number;
  public BudgetLife: number;
  public CompartTypeId: number;
  public Position: number;
  public CompartId: number;


  public ShoeSize: number;
  public Grouser: number;

  public CompartTypeTitle: string;
  public HoursAtInstall: number;

  public PartCost: number;
  public MiscCost: number;
  public LabourCost: number;

  public DidNotReplace: boolean;

  public IsBackendVaildatedStatus: boolean;
}



export class ComponentReplacementWillBeEffectActionsWarningViewModel {
  public ShouldAllowToPerform: boolean;

  public Reason: string;

  public Components: ComponentWarningViewModel[];
}


export class ComponentWarningViewModel {
  public GeneralEqUnitId: number;
  public ActionDesc: string;
}




export class MultipleComponentActionRequest {
  public ActionDate: Date;
  public EquipmentId: number;
  public EquipmentSMU: number;
  public Components: ReplacingComponentsOnSystemViewModel[];
  public StringDate: string;

  /**
   *
   */
  constructor(actionDate: Date, equipmentId: number, equipmentSMU: number, components: ReplacingComponentsOnSystemViewModel[], stringDate: string) {
    this.ActionDate = actionDate;
    this.EquipmentId = equipmentId;
    this.EquipmentSMU = equipmentSMU;
    this.Components = components;
    this.StringDate = stringDate;
  }
}

export class GetInvaildActionsOnComponents {
  public EquipmentId: number;
  public ReplaceAtSMU: number;
  public ReplacedDate: Date;
  public GeneralEqUnitIds: number[];

  /**
   *
   */
  constructor(componentIds: number[], equipmentId: number, replacedAtSmu: number, replacedDate: Date) {
    this.GeneralEqUnitIds = componentIds;
    this.EquipmentId = equipmentId;
    this.ReplaceAtSMU = replacedAtSmu;
    this.ReplacedDate = replacedDate;
  }
}


export class AvailableActionsForComponentInInventory {
  public actions = { // previous code new AvailableActionViewModel(46, 'Relube'), new AvailableActionViewModel(10302, 'Regrouser'),removed,  TT-5815
    // new AvailableActionViewModel(10203, 'Reseal Only On Bush'),
    Link: [new AvailableActionViewModel(8, 'Repair Dry Joints'), new AvailableActionViewModel(10805, 'Repair Component')],
    Bushing: [new AvailableActionViewModel(12, 'Turn Pins & Bushings'), new AvailableActionViewModel(10201, 'Replace Bush'), new AvailableActionViewModel(10805, 'Repair Component')],
    Shoe: [ new AvailableActionViewModel(10301, 'Replace with new shoe'), new AvailableActionViewModel(10302, 'Regrouser Shoe'),new AvailableActionViewModel(10805, 'Repair Component')],
    Idler: [new AvailableActionViewModel(10401, 'Replace With New Idler'), new AvailableActionViewModel(17, 'Swap Front Rear Idler'), new AvailableActionViewModel(10805, 'Repair Component')],
    CarrierRoller: [new AvailableActionViewModel(10602, 'SwapCarrierRollerPosition'), new AvailableActionViewModel(10601, 'Replace With New Carrier Roller'), new AvailableActionViewModel(10805, 'Repair Component')],
    TrackRoller: [new AvailableActionViewModel(10702, 'SwapTrackRollerPosition'), new AvailableActionViewModel(10701, 'Replace With New Track Roller'), new AvailableActionViewModel(10805, 'Repair Component')],
    Sprocket: [new AvailableActionViewModel(10501, 'Replace With New Sprocket'), new AvailableActionViewModel(10805, 'Repair Component')],
    Guard: [new AvailableActionViewModel(10801, 'Replace With New Guard'), new AvailableActionViewModel(10805, 'Repair Component')],
    NoActions: [new AvailableActionViewModel(0, 'No Actions Available'), new AvailableActionViewModel(10805, 'Repair Component')],
    Crawler: [new AvailableActionViewModel(10803, 'Replace With New Crawler Frame Guide'), new AvailableActionViewModel(10805, 'Repair Component')],
    RSRearIdler: [new AvailableActionViewModel(10804, 'Replace With New RS Rear Idler'), new AvailableActionViewModel(10805, 'Repair Component')],

  };


  public GetActions(compartTypeId: number) {
    switch (compartTypeId) {
      case 230: return this.actions.Link;
      case 231: return this.actions.Bushing;
      case 232: return this.actions.Shoe;
      case 233: return this.actions.Idler;
      case 234: return this.actions.CarrierRoller;
      case 235: return this.actions.TrackRoller;
      case 236: return this.actions.Sprocket;
      case 237: return this.actions.Guard;
      case 417: return this.actions.Crawler;
      case 446: return this.actions.RSRearIdler;
      default: return this.actions.NoActions;
    }
  }







}

export class recordActionService {
  public newSystemId: number
  public oldSystemId: number;
  public replaceComponentIDs: string;
  constructor(newSystemId: number, oldSystemId: number, replaceComponentIDs: string) {
    this.newSystemId = newSystemId;
    this.oldSystemId = oldSystemId;
    this.replaceComponentIDs = replaceComponentIDs;
  }
}
